import React, { Component } from 'react';
import { Form, FormItem, withRouter } from '../../Components/Items'
import { Button, Divider, Input, message, Result, Spin } from 'antd';
import axios from 'axios';
import { ArrowLeftOutlined, FacebookOutlined, InstagramOutlined } from '@ant-design/icons';

class RegistroPago extends Component {
  formRef = React.createRef()

  state = {
    loading: false,
    pagoId: null,
    nombre: '',
    loadingConekta: false,
    estadoPago: 1,
    pago: false
  }

  componentDidMount() {

    if (window.ConektaCheckoutComponents) {
      window.location.reload()
    }

    // Make sure the Conekta script is loaded before initializing
    if (this.props.location?.state?.id) {
      this.setState({ loading: true, loadingConekta: true })
      axios
        .post(
          "registroPago/datosPago",
          { empresaId: this.props.empresaId, registroId: this.props.location?.state?.id },
          { headers: this.props.headersToken }
        )
        .then((res) => {
          this.setState({ loading: false })
          if (res.data.success === 2) {
            this.setState({ pagoId: res.data.pagoId, pago: true, loading: false, nombre: res.data.corredorNombre }, () => {
              this.loadConektaScript(res.data.pagoId);
            })
          } else {
            message.error("Error no se encontro informacion de pago de la referencia");
          }
        });
    }
  }

  async onFinish(values) {
    this.setState({ loading: true, loadingConekta: true })
    axios
      .post(
        "registroPago/datosPagoFolio",
        { empresaId: this.props.empresaId, ...values },
        { headers: this.props.headersToken }
      )
      .then((res) => {
        this.setState({ loading: false })
        if (res.data.success === 2) {
          this.setState({ pagoId: res.data.pagoId, pago: true, loading: false, nombre: res.data.corredorNombre, estadoPago: res.data.estadoPago }, () => {
            if (res.data.estadoPago !== 3 && res.data.estadoPago !== 2) {
              this.loadConektaScript(res.data.pagoId);
            }
          })
        } else {
          if (res.data.message) {
            message.info(res.data.message);
          } else {
            message.warning("Error no se encontro informacion de la referencia");
          }
        }
      });
  }

  loadConektaScript(pagoId) {
    const script = document.createElement('script');
    script.src = 'https://pay.conekta.com/v1.0/js/conekta-checkout.min.js'; // Make sure the script URL is correct
    script.async = true;
    script.onload = () => this.initializeConektaCheckout(pagoId);
    document.body.appendChild(script);
  }

  initializeConektaCheckout(pagoId) {
    const options = {
      backgroundMode: 'lightMode', // lightMode or darkMode
      colorPrimary: '#081133', // botones y bordes
      colorText: '#585987', // títulos
      colorLabel: '#585987', // input labels
      inputType: 'minimalMode', // minimalMode or flatMode
    };

    const config = {
      locale: 'es',
      publicKey: 'key_7ILL8f7D4kRgJ0YrmQ1AFG6', // Replace with your actual public key
      targetIFrame: '#conekta_pago', // Make sure this ID matches the target container
      checkoutRequestId: pagoId, // Replace with actual checkout request ID
    };

    const infoSuccessFunction = (loadingTime) => {
      this.setState({ loadingConekta: false })
    }

    const checarPago = (orderId) => {
      this.setState({ loading: true, loadingConekta: true })
      axios
        .post(
          "registroPago/checarPago",
          { empresaId: this.props.empresaId, orderId },
          { headers: this.props.headersToken }
        )
        .then((res) => {
          this.setState({ loading: false, loadingConekta: false })
          if (res.data.success === 2) {
            this.setState({ estadoPago: res.data.estadoPago })
          } else if (res.data.success === 1) {
            message.warning(res.data.message);
          } else {
            message.error("Error no se encontro informacion de pago del folio");
          }
        });
    }

    const callbacks = {
      onGetInfoSuccess: (loadingTime) => infoSuccessFunction(loadingTime),
      onFinalizePayment: (data) => checarPago(data.id),
      onErrorPayment: function (error) {
        console.log('error en pago: ', error);
      },
    };

    window.ConektaCheckoutComponents.Integration({
      config,
      callbacks,
      options,
    });

  }

  render() {
    return (
      <div className='registro-carrera-backgorund'>
        <Spin spinning={this.state.loading}>
          {this.state.pago ?
            <div className="registro-carrera-container-conekta">
              <h1 className="registro-carrera-title">
                <ArrowLeftOutlined style={{ paddingRight: 20 }} onClick={() => {
                  if (window.ConektaCheckoutComponents) {
                    window.location.reload()
                  }
                  this.setState({ pagoId: null, pago: false, nombre: '', estadoPago: 1 }, () => {
                    this.props.navigate('/registroPago')
                  })
                }} />
                Pago #TodosSomosDiferentes
              </h1>
              <div className='registro-carrera-form-conekta' style={{ border: '1px solid #ccc', padding: 0 }}>
                <h2>{this.state.nombre}</h2>
                {this.state.estadoPago === 3 ?
                  <>
                    <Result
                      status="success"
                      title="Pago registrado con exito, muchas gracias!!!"
                      subTitle="Ya hemos registrado su pago exitosamente. Podra pasar por el uniforme a nuestras oficinas en las fechas antes mostradas."
                      extra={[
                        <Button type="primary" key="console" onClick={() => {
                          if (window.ConektaCheckoutComponents) {
                            window.location.reload()
                          }
                          this.setState({ pagoId: null, pago: false, nombre: '', estadoPago: 1 }, () => {
                            this.props.navigate('/registroPago')
                          })
                        }}
                        >
                          Salir
                        </Button>,
                      ]}
                    />
                    <Divider style={{ color: 'black', borderColor: 'black' }} />
                    <div className="registro-carrera-redes">
                      <a href="https://www.facebook.com/IntegrameDown" target="_blank" rel="noopener noreferrer">
                        <FacebookOutlined style={{ fontSize: '24px', marginRight: '10px', color: '#3b5998' }} />
                      </a>
                      <a href="https://www.instagram.com/integramedown" target="_blank" rel="noopener noreferrer">
                        <InstagramOutlined style={{ fontSize: '24px', color: '#e1306c' }} />
                      </a>
                    </div>
                    <div className="registro-carrera-links">
                      <p>
                        Consulta los
                        <a href="/terminosYCondiciones" target="_blank" rel="noopener noreferrer"> Términos y Condiciones</a>,
                        <a href="/politicaPrivacidad" target="_blank" rel="noopener noreferrer"> Aviso de Privacidad</a>, y
                        <a href="/politicaCancelacion" target="_blank" rel="noopener noreferrer"> Política de Cancelación y Devolución</a>.
                      </p>
                    </div>
                  </>
                  :
                  <Spin tip='Cargando pago...' spinning={this.state.loadingConekta}>
                    <p style={{ textAlign: 'center', color: '#333', marginBottom: '.5em' }}>Por pago con tarjeta se cobra $15 por servicio en linea</p>
                    <div id='conekta_pago' style={{ height: '500px', padding: 0 }}>
                      {/* This will be the iframe or container for the Conekta checkout */}

                    </div>
                    <p style={{ textAlign: 'center', color: '#333', marginBottom: '1em', fontSize: '.8rem' }}>Otros metodos de pago: </p>
                    <p style={{ color: '#333', marginBottom: '.5em', marginLeft: '1em', fontSize: '.8rem' }}> <strong>Efectivo:</strong> Se puede dejar en efectivo en Integrame Down</p>
                    <p style={{ color: '#333', marginBottom: '.5em', marginLeft: '1em', fontSize: '.8rem' }}> <strong>Transferencia:</strong> Se puede hacer una transferencia a</p>
                    <p style={{ color: '#333', marginBottom: '3em', marginLeft: '1em', fontSize: '.8rem' }}> <strong>CLABE: 030700900000071331</strong> y mandar mensaje a (444) 205 - 3625</p>
                    <Divider style={{ color: 'black', borderColor: 'black' }} />
                    <div className="registro-carrera-redes">
                      <a href="https://www.facebook.com/IntegrameDown" target="_blank" rel="noopener noreferrer">
                        <FacebookOutlined style={{ fontSize: '24px', marginRight: '10px', color: '#3b5998' }} />
                      </a>
                      <a href="https://www.instagram.com/integramedown" target="_blank" rel="noopener noreferrer">
                        <InstagramOutlined style={{ fontSize: '24px', color: '#e1306c' }} />
                      </a>
                    </div>
                    <div className="registro-carrera-links">
                      <p>
                        Consulta los
                        <a href="/terminosYCondiciones" target="_blank" rel="noopener noreferrer"> Términos y Condiciones</a>,
                        <a href="/politicaPrivacidad" target="_blank" rel="noopener noreferrer"> Aviso de Privacidad</a>, y
                        <a href="/politicaCancelacion" target="_blank" rel="noopener noreferrer"> Política de Cancelación y Devolución</a>.
                      </p>
                    </div>
                  </Spin>
                }
              </div>

            </div>

            :
            <div className="registro-carrera-container">
              <h1 className="registro-carrera-title">
                <ArrowLeftOutlined style={{ paddingRight: 20 }} onClick={() => {
                  this.props.navigate('/registroCarrera')
                }} />
                Pago #TodosSomosDiferentes
              </h1>
              <Form
                ref={this.formRef}
                layout="vertical"
                name="registroPagoFolio"
                onFinish={this.onFinish.bind(this)}
                onFinishFailed={() => { }}
                className="registro-carrera-form"
              >
                <FormItem
                  label="Referencia"
                  required
                  name="busqueda"
                >
                  <Input
                    placeholder="Referencia"
                  />
                </FormItem>

                <FormItem noStyle>
                  <Button style={{ width: '100%' }} type="primary" htmlType="submit" className="registro-carrera-button">
                    Buscar
                  </Button>
                </FormItem>
                <Divider style={{ color: 'black', borderColor: 'black' }} />
                <div className="registro-carrera-redes">
                  <a href="https://www.facebook.com/IntegrameDown" target="_blank" rel="noopener noreferrer">
                    <FacebookOutlined style={{ fontSize: '24px', marginRight: '10px', color: '#3b5998' }} />
                  </a>
                  <a href="https://www.instagram.com/integramedown" target="_blank" rel="noopener noreferrer">
                    <InstagramOutlined style={{ fontSize: '24px', color: '#e1306c' }} />
                  </a>
                </div>
                <div className="registro-carrera-links">
                  <p>
                    Consulta los
                    <a href="/terminosYCondiciones" target="_blank" rel="noopener noreferrer"> Términos y Condiciones</a>,
                    <a href="/politicaPrivacidad" target="_blank" rel="noopener noreferrer"> Aviso de Privacidad</a>, y
                    <a href="/politicaCancelacion" target="_blank" rel="noopener noreferrer"> Política de Cancelación y Devolución</a>.
                  </p>
                </div>
              </Form>
            </div>
          }
        </Spin>
      </div>
    );
  }
}

export default withRouter(RegistroPago);